import styled from "styled-components";

export const StyledHeader = styled.h1`
    text-align: center;
`;